/* Business gifting page v2: gift picker + monthly picker.
   Both pickers add one line to the cart and go straight to checkout. They
   write the PostHog join key (_ph_distinct_id) to the cart before leaving,
   the same way the subscribe page's fast-checkout path does (TRACKING.md §4),
   so business orders join back to their PostHog person. */
(function () {
  if (window.__bv2Init) return;
  window.__bv2Init = true;

  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var phId = function () {
    try {
      var p = window.posthog;
      if (p && p.__loaded && typeof p.get_distinct_id === 'function') return p.get_distinct_id() || null;
    } catch (e) { /* ignore */ }
    return null;
  };

  var post = function (path, body, timeout) {
    var opts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    };
    if (timeout && typeof AbortSignal !== 'undefined' && AbortSignal.timeout) opts.signal = AbortSignal.timeout(timeout);
    return fetch(cartRoot + path, opts);
  };

  var money = function (cents, currency) {
    var whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(whole ? 0 : 2);
    }
  };

  var clampQty = function (value, min, max) {
    var n = parseInt(value, 10);
    if (isNaN(n) || n < min) n = min;
    if (n > max) n = max;
    return n;
  };

  /* Cart attributes ride on the order, so the team can spot a business order
     in admin and knows how many recipients to expect. Capped at 900ms: a slow
     write must never hold up checkout. */
  var writeAttributes = function (extra) {
    var attributes = extra || {};
    var id = phId();
    if (id) attributes._ph_distinct_id = id;
    return Promise.race([
      post('cart/update.js', { attributes: attributes }, 900).catch(function () { /* best-effort */ }),
      new Promise(function (res) { setTimeout(res, 900); })
    ]);
  };

  var checkout = function (btn, item, attributes, onError) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding…';
    var reset = function () { btn.removeAttribute('aria-busy'); btn.textContent = label; };
    post('cart/add.js', { items: [item] }, 12000)
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error((j && (j.description || j.message)) || 'add failed'); });
        return writeAttributes(attributes);
      })
      .then(function () { window.location.href = cartRoot + 'checkout'; })
      .catch(function (err) { reset(); onError(err); });
    /* Back button restores the page mid-add from the bfcache: re-arm. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) reset(); });
  };

  /* Enquiry conversion. Shopify's contact form reloads the page with
     ?contact_posted=true when the "pay by invoice" form was sent. Publish one
     custom customer event for it, which the Google Ads lead pixel
     (web-pixel/google-ads-lead-pixel.js) listens for, and capture it in
     PostHog. sessionStorage stops a refresh from counting twice. */
  (function () {
    try {
      if (new URLSearchParams(window.location.search).get('contact_posted') !== 'true') return;
      if (sessionStorage.getItem('bv2EnquirySent') === '1') return;
      sessionStorage.setItem('bv2EnquirySent', '1');
      var send = function () {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('business_enquiry_submitted', { page: window.location.pathname });
        }
        if (window.posthog && typeof window.posthog.capture === 'function') {
          window.posthog.capture('business_enquiry_submitted');
        }
      };
      /* Both libraries load after this script on a cold page. */
      if (document.readyState === 'complete') send();
      else window.addEventListener('load', send);
    } catch (e) { /* tracking must never break the page */ }
  })();

  /* Stepper wiring shared by both pickers. */
  var bindQty = function (root, onChange) {
    var input = root.querySelector('[data-bv2-qty]');
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 999;
    var set = function (n) { input.value = clampQty(n, min, max); onChange(); };
    root.querySelectorAll('[data-bv2-step]').forEach(function (b) {
      b.addEventListener('click', function () { set(clampQty(input.value, min, max) + parseInt(b.getAttribute('data-bv2-step'), 10)); });
    });
    root.querySelectorAll('[data-bv2-preset], [data-bv2-ladder]').forEach(function (b) {
      b.addEventListener('click', function () { set(b.getAttribute('data-bv2-preset') || b.getAttribute('data-bv2-ladder')); });
    });
    input.addEventListener('input', onChange);
    input.addEventListener('blur', function () { set(input.value); });
    return function () { return clampQty(input.value, min, max); };
  };

  /* ── One-off gift picker ─────────────────────────────────── */
  document.querySelectorAll('[data-bv2-picker]').forEach(function (root) {
    var currency = root.getAttribute('data-currency') || 'AUD';
    var tiers = [];
    try { tiers = JSON.parse(root.getAttribute('data-tiers')) || []; } catch (e) { /* no tiers */ }
    tiers.sort(function (a, b) { return a.qty - b.qty; });

    var el = function (name) { return root.querySelector('[data-bv2-' + name + ']'); };
    var buy = el('buy');
    var error = el('error');
    var invoiceLinks = document.querySelectorAll('[data-bv2-invoice]');

    var selected = function () {
      var input = root.querySelector('input[name="bv2-size"]:checked');
      return {
        variant: input.value,
        price: parseInt(input.getAttribute('data-price'), 10),
        name: input.getAttribute('data-name')
      };
    };

    var qty = bindQty(root, function () { render(); });

    function render() {
      var size = selected();
      var n = qty();
      var tier = null;
      var next = null;
      tiers.forEach(function (t) {
        if (n >= t.qty) tier = t;
        else if (!next) next = t;
      });
      var pct = tier ? tier.pct : 0;
      var full = size.price * n;
      var saving = Math.round(full * pct / 100);
      var total = full - saving;

      el('each').textContent = money(Math.round(total / n), currency);
      var was = el('was');
      was.textContent = money(size.price, currency);
      was.hidden = !pct;
      el('count').textContent = n + ' × ' + size.name;
      el('full').textContent = money(full, currency);
      el('saving-row').hidden = !pct;
      el('saving-label').textContent = 'You save (' + pct + '% off)';
      el('saving').textContent = '−' + money(saving, currency);
      el('total').textContent = money(total, currency);
      el('nudge').textContent = next
        ? 'Add ' + (next.qty - n) + ' more and each gift is ' + next.pct + '% off.'
        : '';

      /* Ladder: per-person price at each tier for the chosen size. */
      var activeMin = tier ? tier.qty : 1;
      root.querySelectorAll('[data-bv2-ladder]').forEach(function (step) {
        var stepPct = parseInt(step.getAttribute('data-pct'), 10) || 0;
        step.querySelector('[data-bv2-ladder-price]').textContent = money(Math.round(size.price * (100 - stepPct) / 100), currency);
        step.setAttribute('aria-pressed', String(parseInt(step.getAttribute('data-bv2-ladder'), 10) === activeMin));
      });
      /* Size cards show what each size costs per person at this quantity. */
      root.querySelectorAll('input[name="bv2-size"]').forEach(function (input) {
        var card = input.parentNode;
        var base = parseInt(input.getAttribute('data-price'), 10);
        card.querySelector('[data-bv2-card-price]').textContent = money(Math.round(base * (100 - pct) / 100), currency);
        var cardWas = card.querySelector('[data-bv2-card-was]');
        cardWas.textContent = money(base, currency);
        cardWas.hidden = !pct;
        var cardSave = card.querySelector('[data-bv2-card-save]');
        cardSave.textContent = 'Save ' + pct + '%';
        cardSave.hidden = !pct;
        card.classList.toggle('is-discounted', !!pct);
      });
      root.querySelectorAll('[data-bv2-preset]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-bv2-preset'), 10) === n));
      });
      /* The enquiry form records which gift the buyer had picked. */
      invoiceLinks.forEach(function (link) {
        link.setAttribute('data-b2b-plan', 'Invoice: ' + n + ' × ' + size.name);
      });
      /* "Email this to your manager": a plain mailto carrying the selection. */
      var share = el('share');
      if (share) {
        var base = share.getAttribute('href').split('&body=')[0];
        var lines = [
          'I found a gift for the team: each person gets a square metre of protected rainforest with their name on it, on a live map.',
          '',
          n + ' × ' + size.name + ': ' + money(Math.round(total / n), currency) + ' per person, ' + money(total, currency) + ' in total' + (pct ? ' (' + pct + '% quantity discount)' : '') + '.',
          'Delivered by email. Pay by card or invoice.',
          '',
          window.location.origin + window.location.pathname
        ];
        share.setAttribute('href', base + '&body=' + encodeURIComponent(lines.join('\n')));
      }
      error.hidden = true;
    }

    root.querySelectorAll('input[name="bv2-size"]').forEach(function (input) {
      input.addEventListener('change', render);
    });

    buy.addEventListener('click', function () {
      var size = selected();
      var n = qty();
      checkout(
        buy,
        { id: size.variant, quantity: n },
        { 'Business gifting': n + ' × ' + size.name },
        function () {
          error.hidden = false;
        }
      );
    });

    render();
  });

  /* ── Monthly picker ──────────────────────────────────────── */
  document.querySelectorAll('[data-bv2-monthly]').forEach(function (root) {
    var currency = root.getAttribute('data-currency') || 'AUD';
    var price = parseInt(root.getAttribute('data-price'), 10);
    var variant = root.getAttribute('data-variant');
    var plan = root.getAttribute('data-plan');
    var buy = root.querySelector('[data-bv2-buy]');
    var error = root.querySelector('[data-bv2-error]');
    var total = root.querySelector('[data-bv2-total]');

    var qty = bindQty(root, function () { render(); });

    function render() {
      var n = qty();
      total.textContent = n + (n === 1 ? ' Square' : ' Squares') + ' a month · ' + money(price * n, currency) + ' a month';
      error.hidden = true;
    }

    buy.addEventListener('click', function () {
      var n = qty();
      checkout(
        buy,
        { id: variant, quantity: n, selling_plan: plan },
        { 'Business gifting': n + ' × Seed Square monthly' },
        function () { error.hidden = false; }
      );
    });

    render();
  });
})();
